import axios, { AxiosPromise } from 'axios';

export const imprimeEspelhoCadastro = (
  tipoCadastro: string,
  cadastroGeral: string
): AxiosPromise<any> =>
  axios.get(
    `/api/espelho-cadastro-geral/imprimir?tipo-cadastro=${tipoCadastro}&cadastro-geral=${cadastroGeral}`,
    { responseType: 'blob' }
  );

export const imprimeEspelhoCadastroEspecifico = (
  tipoCadastro: string,
  cadastroGeral: string
): AxiosPromise<any> =>
  axios.get(
    `/api/espelho-cadastro-geral/imprimir-especifico?tipo-cadastro=${tipoCadastro}&cadastro-geral=${cadastroGeral}`,
    { responseType: 'blob' }
  );
